import './scripts/common';
import {onFind} from '@elements/init-modules-in-scope';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tooltip from 'bootstrap/js/dist/tooltip';
onFind('[data-bs-toggle="tooltip"]', (element) => {
    new Tooltip(element);
});

// Todo: Add page specific JS here e.g:

import * as dynamicLightbox from './scripts/dynamic-lightbox';
dynamicLightbox.init();

import * as mixedCardTeaserSlider from './scripts/mixed-card-teaser-slider';
mixedCardTeaserSlider.init();

import * as imgTeaserRowSlider from './scripts/img-teaser-row-slider';
imgTeaserRowSlider.init();

import * as video from './scripts/video';
video.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as rerenderItem from './scripts/rerender-item';
rerenderItem.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as ticketCheckbox from './scripts/ticket-checkbox';
ticketCheckbox.init();

import {init} from '@elements/anchor-nav/bootstrap-5'
init({
        renderItem: function (text, anchor) {
            return '<li class="anchor-nav__item nav-item"><a class="nav-link js-smoothscroll__link" data-scroll-offset="250" href="#' + anchor + '">' + text + '</a></li>';
        },
        smoothScroll: true,
        scrollSpy: true,
        scrollSpyTarget: '.js-anchor-nav',
        scrollSpyOffset: 0,
    },
    {
        list: '.js-anchor-nav__list',
        item: '.js-anchor-nav__item'
    }
);

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init({scrollOffset: 1000});

import * as enhancedConversionTracking from '@vdevs/enhanced-conversion-tracking';
const defaultSelectors = {
    base: '.js-enhanced-conversion-tracking',
    input: '.js-enhanced-conversion-tracking__input',
    select: '.js-enhanced-conversion-tracking__select',
    checkbox: '.js-enhanced-conversion-tracking__checkbox',
    btn: '.js-enhanced-conversion-tracking__submit-btn',
};

const defaultOptions = {
    debug: false,
    formEvent: 'form-validation.submit',
    platforms: {
        google: true,
        microsoft: true,
        facebook: true,
        tiktok: false,
        pinterest: false,
    },
};

enhancedConversionTracking.initLeadTracking(defaultOptions,defaultSelectors);

import * as ajaxAccordion from './scripts/ajax-accordion';
ajaxAccordion.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as numberSpinner from '@elements/number-spinner';
numberSpinner.init();

import * as wtpInfo from './scripts/wtp-info';
wtpInfo.init();

import * as brandnamicDynform from './scripts/brandnamic-dynform';
brandnamicDynform.init();

console.log('content.js')
